export const EVENT = {
  INTERACTION: 'interaction'
};
export const COMPONENT = {
  GOALS_TABLE: 'goals-table'
};
export const SUB_COMPONENT = {
  GOAL_DETAILS: 'goal-details'
};
export const INTERACTION_TYPE = {
  GOAL_TARGET_ACTION_VIEW: 'goal-target-action-view',
  EDIT_GOAL_LINK_CLICKED: 'edit-goal-link-clicked',
  ADS_GOALS_CAMPAIGN_LINK_CLICK: 'ads-goals-campaign-link-click',
  VIEW_ALL_CAMPAIGNS_CLICK: 'view-all-campaigns-click'
};